import uuidv4 from 'uuid/v4';

import {
  FileCategories,
  ImageMimeTypes,
  validateFileToUpload,
  VideoMimeTypes,
} from '@mw/validations';

import {
  ALLOWED_MIME_TYPE_FOR_IMAGE_LIST,
  ContentTypes,
  MessageStatus,
  MessageType,
} from '~/constants';

import { deleteMessage } from '~/api/messages';
import { createMessage } from '~/thunks/messages';
import { uploadFile } from '~/api/storage';

import { addFileToImageGallery } from './modals';

const createFileMessage = async ({
  dispatch,
  conversationID,
  enqueueSnackbar,
  file,
  agentID,
}) => {
  const messageID = uuidv4();

  const defaultSrcPayload = {
    mime: null,
    size: null,
    uri: null,
  };

  const fileName = file.name ?? null;

  const message = {
    id: messageID,
    status: MessageStatus.CREATED,
    payload: {
      type: MessageType.FILE,
      category: ContentTypes.UNSPECIFIED,
      name: fileName,
      src: defaultSrcPayload,
      thumbnail: defaultSrcPayload,
      preview: defaultSrcPayload,
    },
  };

  dispatch(
    createMessage({
      conversationID,
      message,
      agentID,
    })
  );

  try {
    const response = await uploadFile(file, messageID);

    if (response.mime_type === ALLOWED_MIME_TYPE_FOR_IMAGE_LIST) {
      dispatch(addFileToImageGallery(response));
    }
  } catch (error) {
    enqueueSnackbar(error.message, { variant: 'error' });

    await deleteMessage(messageID).catch((err) => {
      enqueueSnackbar(err.message, { variant: 'error' });
    });
  }
};

const getFileCategory = ({ attachmentType, provider, mimeType }) => {
  if (attachmentType !== FileCategories.FILE) {
    return attachmentType;
  }

  if (ImageMimeTypes[provider].includes(mimeType)) {
    return FileCategories.IMAGE;
  }

  if (VideoMimeTypes[provider].includes(mimeType)) {
    return FileCategories.VIDEO;
  }

  return attachmentType;
};

export const sendAttachment =
  ({ attachmentType, enqueueSnackbar, file, invalidAttachmentCb = () => {} }) =>
  async (dispatch, getState) => {
    const state = getState();

    const {
      global: { curChatProviderType, curChatAgentID: agentID },
      conversations: {
        selectedConversation: { id: conversationID },
      },
    } = state;

    const { type: mimeType } = file;

    const fileCategory = getFileCategory({
      attachmentType,
      mimeType,
      provider: curChatProviderType,
    });

    try {
      validateFileToUpload(file, curChatProviderType, fileCategory);
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });

      await invalidAttachmentCb();

      return;
    }

    await createFileMessage({
      conversationID,
      file,
      curChatProviderType,
      dispatch,
      enqueueSnackbar,
      agentID,
    });
  };
